/* eslint-disable no-useless-escape */

export const extractOwnerAndRepo = (
  url: string
): { owner: string; repo: string } | null => {
  //* Regex to get the owner and repository from the URL
  const regex = /https:\/\/github\.com\/([^\/]+)\/([^\/]+)/;
  const match = url.match(regex);
  //* If match successful, extract owner and repo
  if (match && match.length === 3) {
    const owner = match[1];
    const repo = match[2];
    return { owner, repo };
  }
  return null;
};
